import React from "react";
import { Link } from "react-router-dom";
import homeStyles from "../../styles/home/NewHome.module.scss";
import styles from "../../styles/home/InfoSection.module.scss";
import classnames from "classnames";
import { Slide } from "react-awesome-reveal";
import { isBrowser, isMobile } from "react-device-detect";

const InfoSection = ({
  topLine,
  headline,
  description,
  buttonLabel,
  img,
  alt,
  imgStart,
  lightBg,
  lightTopLine,
  lightTextDesc,
  textAlign,
  hasButton,
  hasLogo,
  product,
  backgroundImg,
  logoSrc,
  parallax,
  wrapperCustomStyle,
  headlineImage,
  headlineImageStyle,
  descriptionButtonSrc,
  description2,
  descriptionButtonLink,
  headingline2,
  clickableImg = false,
  imgLinkSrc = "",
  transparentBg = false,
  ...props
}) => {
  const alignment = isMobile ? "center" : textAlign;
  const infoSectionClass = classnames({
    [styles.infoSection]: true,
    [styles.lightBg]: lightBg,
    [styles.parallax]: parallax && isBrowser,
    [styles.transparentBackground]: transparentBg ? true : false,
  });

  const infoSectionClassMobile = classnames({
    [styles.infoSectionMobile]: true,
    [styles.lightBg]: lightBg,
    [styles.parallax]: parallax && isBrowser,
  });

  const infoRowClass = classnames({
    [styles.infoRow]: true,
    [styles.imgStart]: imgStart,
  });

  const renderDescription = () => {
    if (isBrowser) {
      return (
        <Slide direction="up" triggerOnce fraction={1}>
          <div >
            <div
             className={classnames(styles.subtitle, styles[product])}
              style={{
                color: lightTextDesc ? "#fff" : "#1c2237",
                textAlign: alignment,
              }}
            >
              <p>{description}</p>
              {description2 && <p style={{marginTop: '24px'}}>{description2}</p>}
              {( product !== 'BB3' && descriptionButtonSrc && descriptionButtonLink ) && <a href={descriptionButtonLink} target="_blank" rel="noopener noreferrer" >
                <img alt="description" src={descriptionButtonSrc} style={{height: '54px', marginTop: "45px"}}/>
              </a>}
              { ( product === 'BB3' && descriptionButtonSrc && descriptionButtonLink ) &&
                <div className={styles.buttonLinkContainer}> 
                  <a href={descriptionButtonLink} target="_blank" rel="noopener noreferrer" className={styles.buttonLink}>
                Set Up Shop
                </a>
                </div>
              }
            </div>
          </div>
        </Slide>
      );
    } else {
      return (
        <div >
          <div
            className={classnames(styles.subtitle, styles[product])}
            style={{
              color: lightTextDesc ? "#fff" : "#1c2237",
              textAlign: alignment,
            }}
          >
             <p>{description}</p>
              {description2 && <p style={{marginTop: '24px'}}>{description2}</p>}
              {( product !== 'BB3' && descriptionButtonSrc && descriptionButtonLink ) && <a href={descriptionButtonLink} target="_blank" rel="noopener noreferrer" >
                <img alt="description" src={descriptionButtonSrc} style={{height: '54px', marginTop: "45px"}}/>
              </a>}
              { ( product === 'BB3' && descriptionButtonSrc && descriptionButtonLink ) &&
                <div className={styles.buttonLinkContainer}> 
                  <a href={descriptionButtonLink} target="_blank" rel="noopener noreferrer" className={styles.buttonLink}>
                Set Up Shop
                </a>
                </div>
              }
          </div>
        </div>
      );
    }
  };


  return (
    <>
      <div
        className={infoSectionClass}
        style={{
          backgroundImage: backgroundImg ? `url(${backgroundImg})` : null,
          ...wrapperCustomStyle,
          // backgroundColor: transparentBg ? "transparent !important" : null,
        }}
      >
        <div className={homeStyles.container}>
          <div className={classnames(infoRowClass, styles[product])}>
            {
              product === "shop" ? <> 
              <div className={classnames(styles.infoColumn, styles[product])}>
                <div
                  className={classnames(styles.textWrapper, styles[product] )}
                  style={{ textAlign: headlineImage ? "left" : "center" }}
                >
                  {hasLogo && <img src={logoSrc} alt="" style={{maxHeight: product ==="BB3" ? "75px" : ""}}/>}
                  <div
                    className={styles.topLine}
                    style={{ color: lightTopLine ? "#a9b3c1" : "#4B59F7" }}
                  >
                    {topLine}
                  </div>

                  {headlineImage ? (
                    <img
                      alt="headline styling"
                      src={headline}
                      style={{
                        width: headlineImageStyle
                          ? headlineImageStyle.width
                          : "auto",
                      }}
                    />
                  ) : (
                    <h1
                      className={classnames(styles.heading, styles[product])}
                      style={{ textAlign: alignment }}
                    >
                      {headline}
                      { product === 'shop' && <>
                        <p>{headingline2}
                        <span className={styles.bbshopText}>Buildbox Shop!</span>
                        </p>     
                      </>
                      }
                    </h1>
                  )} 
                  {renderDescription()}
                  <span> {props.children} </span>
                  {hasButton && (
                    <Link to="/login">
                      <button className={homeStyles.button}>{buttonLabel}</button>
                    </Link>
                  )}
                </div>
              </div>
              <div className={classnames(styles.imgWrapper, styles[product])}>
          
              </div>
              
              </> 
              :

              <> 
              <div className={classnames(styles.infoColumn, styles[product])}>
                <div
                  className={styles.textWrapper}
                  style={{ textAlign: headlineImage ? "left" : "center" }}
                >
                  {hasLogo && <img src={logoSrc} alt="logo" style={{maxHeight: "75px"}}/>}
                  <div
                    className={styles.topLine}
                    style={{ color: lightTopLine ? "#a9b3c1" : "#4B59F7" }}
                  >
                    {topLine}
                  </div>

                  {headlineImage ? (
                    <img
                      alt="headling styling"
                      src={headline}
                      style={{
                        width: headlineImageStyle
                          ? headlineImageStyle.width
                          : "auto",
                      }}
                    />
                  ) : (
                    <h1
                      className={classnames(styles.heading, styles[product])}
                      style={{ textAlign: alignment }}
                    >
                      {headline}
                      { product === 'shop' && <>
                        <p>{headingline2}
                        <span className={styles.bbshopText}>Buildbox Shop!</span>
                        </p>     
                      </>
                      }
                    </h1>
                  )} 
                  {renderDescription()}
                  <span> {props.children} </span>
                  {hasButton && (
                    <Link to="/login">
                      <button className={homeStyles.button}>{buttonLabel}</button>
                    </Link>
                  )}
                </div>
              </div>
              <div className={classnames(styles.imgWrapper, styles[product])}>
              {!clickableImg && img && <img className={classnames(styles.img, styles[product])} src={img} alt={alt} />}
              {clickableImg && img && <Link to="/downloads/bb2"><img className={classnames(styles.img, styles[product])} src={img} alt={alt} /> </Link> }
              </div>
              
              </>
            }

          
          </div>
        </div>
      </div>
      <div
        className={classnames(infoSectionClassMobile, styles[product])}
        style={{
          backgroundImage: backgroundImg ? `url(${backgroundImg})` : null,
        }}
      >
        <div className={classnames(homeStyles.container, styles[product])}>
          <div className={classnames(infoRowClass, styles[product])}>
            <div className={classnames(styles.infoColumn, styles[product])}>
              <div className={styles.textWrapper}>
              {hasLogo && <img src={logoSrc} alt="" style={{maxHeight: product ==="BB3" ? "75px" : ""}}/>}
                <h1
                  className={classnames(styles.heading, styles[product])}
                  style={{ textAlign: alignment }}
                >
                  {headline}
                  { product === 'shop' && <>
                      <p>{headingline2}
                      <span className={styles.bbshopText}>Buildbox Shop!</span>
                      </p>     
                    </>
                    }
                </h1>
                <div className={classnames(styles.imgWrapper, styles[product])}>
                  {!clickableImg && img && <img className={classnames(styles.img, styles[product])} src={img} alt={alt} />}
                  {clickableImg && img && <Link to="/downloads/bb2"><img className={classnames(styles.img, styles[product])} src={img} alt={alt} /> </Link> }
                </div>
                <div
                  className={styles.topLine}
                  style={{ color: lightTopLine ? "#a9b3c1" : "#4B59F7" }}
                >
                  {topLine}
                </div>
                {renderDescription()}
                <span> {props.children} </span>
                {hasButton && (
                  <Link to="/login">
                    <button className={homeStyles.button}>{buttonLabel}</button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfoSection;
